<template>
  <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
    <div slot="spinner">
      <loading-spinner />
    </div>
    <div slot="no-more" />
    <div slot="no-results">
      No results
    </div>
  </infinite-loading>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner';
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'InfiniteScrolling',

  components: {
    LoadingSpinner,
    InfiniteLoading,
  },

  data() {
    return {
      infiniteId: +new Date(),
    };
  },

  methods: {
    infiniteHandler($state) {
      this.$emit('infiniteHandler', $state);
    },
  },
};
</script>
